export enum ENfs {
  NOTA_FISCAL = '1',
  RECIBO = '2'
}
